import request from '@/utils/request'
import { ALL_INBOUNDS_URL } from './endpoints'
import { AllInboundItem, GetAllInboundsReq } from './types'

export { ALL_INBOUNDS_URL, ALL_INBOUNDS_EXCEL_URL } from './endpoints'

/**
 * GR05 입고조회(전체) 조회. (LOGISPRD-9554)
 *
 * ST02·ST07(GET·무페이징)과 달리 **POST + 서버 페이징**이다 — 응답이 `data.items` + `data.pageInfo` 로 온다.
 * 필수 필터(화주명 OR 화주유형)가 비면 BE 가 400 을 주므로 호출부에서 선검증한다(filterToRequest 참조).
 */
export const getAllInbounds = (params: GetAllInboundsReq) =>
  request.post<ApiPaginationV2<AllInboundItem>, GetAllInboundsReq>(ALL_INBOUNDS_URL, params)
